const doc = [({"da":({"js":({"sheet_layouts":({"presentation":({"index":({"zoom":"Zoom", "rotate_left":"Drej til venstre", "rotate_right":"Drej til højre"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;